import * as Sentry from '@sentry/react';

import { getClientConfig, type SentryOptions } from './config/getClientConfig';

export const initSentry = (options: SentryOptions) => {
  if (!Sentry.isInitialized()) {
    Sentry.init(getClientConfig(options));
  }

  return Sentry;
};
